import React,{ Component } from 'react';

import { Button } from 'reactstrap';

import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import DCMTagInput from '../../../shared/components/DCMTagInput';
import TextInput from '../../../shared/components/TextInput';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';

import { validateTags } from '../../../shared/validators';

class CampaignCoverForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      image:null,
      isShowingPopover:false
    };
  }

  componentDidMount(){
    if(this.props.activeCampaignFeedImageURL && this.props.activeCampaignFeedImageFileName){
      this.setState({image:{
        fileName:this.props.activeCampaignFeedImageFileName,
        medium:this.props.activeCampaignFeedImageURL
      }});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(data){
    const validationMessages = {};

    const image = this.state.image;

    if(image){
      data.feedImageURL = image.medium;
      data.feedImageFileName = image.fileName;
      data.feedImageFileId = image.id;
    }

    if(!image || !image.medium || image.medium === ""){
      validationMessages['image'] = 'Image is required';
    }

    validationMessages['tags'] = validateTags(data.tags);

    if(validationMessages['tags'].every((o) => o.length === 0)){
      delete validationMessages['tags'];
    }


    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  handleImageChange(newImage){
    this.setState({image:newImage});
  }

  handleTextChange(newText){
    // console.log('TEXT IS NOW = ',newText);
  }

  render(){
    return (
      <Form
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target='FeedTextInput'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Cover Tile'
        >
          <p>
            The title your audience will see.  It can be the theme of the rest of your experience.  <br /><br />
            Examples:<br />
            Introducing {this.props.activeCampaignBrandName}<br />
            See what's new at {this.props.activeCampaignBrandName}<br />
            Nice to meet you
          </p>
        </TutorialPopover>
        <TextInput
          id='FeedTextInput'
          label='Text'
          name='feedText'
          defaultValue={this.props.activeCampaignFeedText}
          placeholder='Introducing our brand and product'
          maxLength={50}
          multiline
          warning={this.state.validationMessages['feedText']}
          onChange={(text) => this.handleTextChange(text)}
        />
        <DroppableFileInput
          label='Image'
          fileType='image'
          name='feedImage'
          text='Upload cover tile image'
          onChange={(image) => this.handleImageChange(image)}
          warning={this.state.validationMessages['image']}
          cropperAspectRatio={1/1}
          existingFileName={this.props.activeCampaignFeedImageFileName}
          existingFileURL={this.props.activeCampaignFeedImageURL}
          tooltip={(
            <span>Use a large crisp 1x1 image.<br />We recommend 800px by 800px.<br />Maximum file size of 2MB.</span>
          )}
        />
        <DCMTagInput
          type='feed'
          name='tags'
          defaultValue={this.props.activeCampaignFeedTags}
          warning={this.state.validationMessages['tags']}
        />
        <br />
        {/*<TextInput
          id='CampaignDCMInput'
          label='DCM Tracking Tag'
          name='dcmTag'
          multiline
          defaultValue={this.props.activeCampaignDCMTag}
          tooltip={(<span>Including tag allows you to track impressions in your DCM dashboard.</span>)}
          placeholder='Full tag or URL'
          warning={this.state.validationMessages['campaignDCMTag']}
        />*/}

        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignCoverForm.defaultProps = {
  onChange:() => {},
  onSubmit:() => {},
  isShowingTutorial:true,
  showSuperadminFeatures:false
};

export default CampaignCoverForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignCoverForm.js